import { render, staticRenderFns } from "./formFilterStudentScholarship.vue?vue&type=template&id=5287371a&scoped=true&"
import script from "./formFilterStudentScholarship.vue?vue&type=script&lang=js&"
export * from "./formFilterStudentScholarship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5287371a",
  null
  
)

export default component.exports